import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import React from "react";
import PropTypes from "prop-types";
import { Tooltip } from "@mui/material";

import { useUser } from "../../auth/UserProvider";
import extractInitials from "../../utils/userUtilites";

import GroupList from "./GroupList";

const UserAccount = ({ fullWidth = false }) => {
  const { name } = useUser();

  const [anchorEl, setAnchorEl] = React.useState(null);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      {name && (
        <>
          <Tooltip title="See your groups">
            <Button
              // disabled
              fullWidth={fullWidth}
              startIcon={
                <Avatar
                  style={{ width: 25, height: 25, color: "rgb(2, 31, 71)", fontSize: "0.80rem" }}
                  variant="circle"
                >
                  {extractInitials(name)}
                </Avatar>
              }
              style={{
                backgroundColor: "transparent",
                color: "white",
                border: "none",
                outline: "none",
                boxShadow: "none",
              }}
              variant="text"
              onClick={handleClick}
            >
              <Typography key="Typography-Button" variant="body2">
                {name}
              </Typography>
            </Button>
          </Tooltip>
          {open && <GroupList anchorEl={anchorEl} handleClose={handleClose} open={open} />}
        </>
      )}
    </>
  );
};

UserAccount.propTypes = {
  fullWidth: PropTypes.bool,
};

export default UserAccount;
